/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React from 'react';
import clsx from 'clsx';
import {
  Avatar,
  useChatContext,
} from 'stream-chat-react';

import { Typography } from '@mui/material';
import { channelByUser } from './utils';

const SearchResult = (props) => {
  const {
    focusedId,
    result,
    setChannel,
  } = props;

  const {
    client,
    setActiveChannel,
  } = useChatContext();

  if (result.cid !== undefined) { // isChannel
    const channel = result;

    return (
      <div
        onClick={() => setChannel(channel)}
        className={clsx(
          'channel-search__result-container',
          { highlighted: focusedId === channel.id },
        )}
      >
        <Avatar
          image={channel?.data?.image}
          name={channel?.data?.name}
          size={24}
        />
        <Typography fontWeight={500}>{channel?.data?.name}</Typography>
      </div>
    );
  }
  const user = result;

  return (
    <div
      onClick={() => {
        channelByUser({
          client,
          setActiveChannel,
          user,
        });
      }}
      className={clsx(
        'channel-search__result-container',
        { highlighted: focusedId === user.id },
      )}
    >
      <Avatar
        image={user.image}
        name={user.name || user.id}
        size={24}
      />
      <Typography>{user.name || user.id || 'Johnny Blaze'}</Typography>
    </div>
  );
};

export const ResultsDropdown = (props) => {
  const {
    teamChannels,
    directChannels,
    focusedId,
    loading,
    setChannel,
    setQuery,
  } = props;
  document.addEventListener('click', () => setQuery(''));

  return (
    <div className="channel-search__results">
      <p className="channel-search__results-header">Channels</p>
      {loading && !teamChannels?.length && (
        <p className="channel-search__results-header">
          <i>Loading...</i>
        </p>
      )}
      {!loading && !teamChannels?.length
        ? (
          <p className="channel-search__results-header">
            <i>No channels found</i>
          </p>
        )
        : (
          teamChannels?.map((channel, i) => (
            <SearchResult result={channel} focusedId={focusedId} key={i} setChannel={setChannel} />
          ))
        )}
      <p className="channel-search__results-header">Users</p>
      {loading && !directChannels?.length && (
        <p className="channel-search__results-header">
          <i>Loading...</i>
        </p>
      )}
      {!loading && !directChannels?.length
        ? (
          <p className="channel-search__results-header">
            <i>No direct messages found</i>
          </p>
        )
        : (
          directChannels?.map((user, i) => (
            <SearchResult result={user} focusedId={focusedId} key={i} setChannel={setChannel} />
          ))
        )}
    </div>
  );
};
